import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { RootState } from '../../app/store';
import Localized from '../../Localized';
import { ProductInfo } from '../types/order';

import { UserInfo } from '../types/user';

interface ProductResponse {
  response: string;
  method: string;
  token: string;
  maxTotal: number;
  service: string;
  link: string;
  items: ProductInfo[];
}

export const api = createApi({
  baseQuery: fetchBaseQuery({ 
    baseUrl: 'https://ticketok.by/api',
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).userSlice.token;
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
    
  }),
  
  endpoints: (builder) => ({

    getToken: builder.query<UserInfo[], void>({
      query: () => '/user/user.authorize.php?lang='+Localized.getLanguage(),
    }),

    closeSession: builder.mutation<UserInfo[], void>({
      query: () => ({
        url: '/user/user.close.php',
        method: 'POST',
      }),
      
    }),

    getProducts: builder.mutation<ProductResponse, {}>({
      query: (id) => ({
        url: '/store/store.getProducts.php?ticket_id='+id,
        method: 'POST',
      }),
    }),

    updateProducts: builder.mutation<any, FormData>({
      query: (formData) => ({
        url: '/order/order.update2.php',
        method: 'POST',
        body: formData,
      }),
    }),

    sendContactInfo: builder.mutation<any, FormData>({
      query: (formData) => ({
        url: '/order/order.payment.php',
        method: 'POST',
        body: formData,
      }),
    }),

  }),
  
});


export const { useGetTokenQuery, useCloseSessionMutation, useGetProductsMutation, useUpdateProductsMutation, useSendContactInfoMutation } = api;